// design/028 — Monthly / Yearly choice shared by the registration page and
// the Billing paywall. Yearly is pre-selected when it's on sale.
export const PLANS = {
  yearly: { key: 'yearly', label: 'Yearly', price: '$49.99', per: 'year', note: '$4.17 / month' },
  monthly: { key: 'monthly', label: 'Monthly', price: '$4.99', per: 'month', note: 'Billed monthly' },
};

export const YEARLY_TAGLINE = 'Choose yearly plan and get 2 months free!';

export const defaultPlan = (sub) => (sub?.yearlyAvailable ? 'yearly' : 'monthly');

/** "$49.99 / year" */
export const priceLine = (plan) => `${PLANS[plan].price} / ${PLANS[plan].per}`;

/** Fine print under the button. */
export function planTerms(plan, trial) {
  const p = PLANS[plan];
  return trial
    ? `Your card is collected now but not charged during the 7-day trial. After the trial, you'll be charged ${p.price} every ${p.per} until you cancel. Cancel before the trial ends and you won't be charged. One free trial per person.`
    : `You'll be charged ${p.price} today and every ${p.per} until you cancel. This account has already used its free trial.`;
}

export default function PlanPicker({ value, onChange, disabled }) {
  const opt = (plan) => {
    const p = PLANS[plan];
    const on = value === plan;
    return (
      <button type="button" key={plan} disabled={disabled} onClick={() => onChange(plan)}
        aria-pressed={on}
        style={{
          flex: 1, textAlign: 'left', cursor: disabled ? 'default' : 'pointer', position: 'relative',
          padding: '12px 14px', borderRadius: 12, background: on ? 'var(--accent-soft, #eef2ff)' : '#fff',
          border: on ? '2px solid var(--accent, #4f46e5)' : '1px solid var(--border)',
        }}>
        <div style={{ fontWeight: 700 }}>{p.label}</div>
        <div style={{ fontSize: '1.05rem', fontWeight: 800, marginTop: 2 }}>{priceLine(plan)}</div>
        <div style={{ fontSize: '0.78rem', color: 'var(--muted)' }}>{p.note}</div>
      </button>
    );
  };
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', gap: 10 }}>
        {opt('yearly')}
        {opt('monthly')}
      </div>
      <div style={{ marginTop: 8, fontSize: '0.85rem', fontWeight: 600, color: '#166534' }}>
        {YEARLY_TAGLINE}
      </div>
    </div>
  );
}
